import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

class FamBundlesApi {
    constructor() {
        this.baseUrl = 'api/partnerships/v1/fam/bundles';
    }

    buildQuery(params = {}) {
        const searchParams = new URLSearchParams();

        if (params.key) searchParams.set('key', params.key);
        if (params.source) searchParams.set('source', params.source);

        const query = searchParams.toString();
        return query ? `?${query}` : '';
    }

    async bulkUpload(file, { source, week, year } = {}) {
        const respObj = { data: {}, msg: '', status: false };

        try {
            const formData = new FormData();
            formData.append('file', file);

            // Send week/year in the form payload; always send source as a query param.
            if (week !== undefined && week !== null && week !== '') formData.append('week', String(week));
            if (year !== undefined && year !== null && year !== '') formData.append('year', String(year));

            const url = `${this.baseUrl}/bulk/upload${this.buildQuery({ source })}`;
            const response = await mmFetch(url, {
                body: formData,
                headers: {}, // Let browser set Content-Type for multipart
                method: 'POST',
            });

            if (response.status === 200) {
                const decodedResp = await response.json();
                respObj.status = true;
                respObj.msg = decodedResp.msg;
                respObj.data = decodedResp.data;
            } else {
                try {
                    const decodedResp = await response.json();
                    respObj.msg = decodedResp.msg || 'Upload failed';
                    respObj.data = decodedResp.data || {};
                } catch (error) {
                    console.error('Error decoding response:', error);
                    respObj.msg = `Upload failed with status ${response.status}`;
                }
            }
        } catch (e) {
            // Re-throw AbortError so TanStack Query can handle cancellation
            if (e.name === 'AbortError') {
                throw e;
            }
            respObj.msg = `Upload error: ${e.message}`;
        }

        return respObj;
    }

    async bulkFetch(key, { source } = {}, signal) {
        const url = `${this.baseUrl}/bulk/fetch${this.buildQuery({ key, source })}`;
        return mmFetchWithResponse(url, { signal });
    }

    async bulkEdit(key, { source } = {}, rowsToUpdate, rowsToDelete) {
        const url = `${this.baseUrl}/bulk/edit${this.buildQuery({ source })}`;
        return mmFetchWithResponse(url, {
            body: JSON.stringify({
                key,
                rowsToDelete,
                rowsToUpdate,
            }),
            method: 'PUT',
        });
    }

    async bulkPersist(key, { source } = {}) {
        const url = `${this.baseUrl}/bulk/persist${this.buildQuery({ source })}`;
        return mmFetchWithResponse(url, {
            body: JSON.stringify({ key }),
            method: 'PUT',
        });
    }

    async getWeekYearForBundleCreation(source) {
        const url = `${this.baseUrl}/week-year${this.buildQuery({ source })}`;
        return mmFetchWithResponse(url);
    }
}

export const famBundlesApi = new FamBundlesApi();
export { FamBundlesApi };
